<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/95LzYK/cover.jpg?1701060818470" alt="This image is the cover for the book Outlander"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Outlander
      </h1>
      <p class="bookDescription body article font2">
        <b>Fiction and nonfiction form compelling counterpoints in this powerful look at love and lesbianism  </b><br/>The stories and essays in this anthology depict homosexuality in all its variegated forms.   In “Home Movie,” Alysoun Carr, a clarinetist with the San Francisco Symphony, learns about overcoming fear from a woman named Constantina. “In the Attic of the House” depicts sixty-five-year-old Alice, who rents rooms to younger gay women who have no inkling of Alice’s tragic lesbian past. “Outlander” is about a widowed alcoholic trying to stay sober through a war that will take her son and, possibly, her longtime lover. “Sexuality in Literature” is a lively essay about everything from the homophobia that exists in all of us to the new words that need to be invented for female sexuality.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Rule
      </h2>
      
      <p class="authorDescription body article">Jane Rule (1931&ndash;2007) was the author of several novels and essay collections, including the groundbreaking lesbian love story<i>&#160;Desert of the Heart</i> (1964),which was made into the feature film <i>Desert Hearts</i>. She was inducted into the Order of Canada in 2007. Born in New Jersey, Rule moved to Canada in 1956, and lived on Galiano Island, British Columbia, until her death at the age of seventy-six.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4aebc58